// Material 3 icon tile: a tonal container that holds a Material Symbol inside a card or list item.
// Every tone is a role/on-role pair (container + on-container), so contrast is guaranteed in every scheme.
// Props: icon (symbol name), tone ('primary' | 'secondary' | 'tertiary' | 'error' | 'success' | 'neutral'),
//        size ('sm' 32 | 'md' 40 | 'lg' 56), shape (M3 shape token suffix, default 'medium'), filled, sx
(function () {
  const TONES = {
    primary: ['var(--m3-primary-container)', 'var(--m3-on-primary-container)'],
    secondary: ['var(--m3-secondary-container)', 'var(--m3-on-secondary-container)'],
    tertiary: ['var(--m3-tertiary-container)', 'var(--m3-on-tertiary-container)'],
    error: ['var(--m3-error-container)', 'var(--m3-on-error-container)'],
    success: ['var(--m3-success-container)', 'var(--m3-on-success-container)'],
    neutral: ['var(--m3-surface-container-highest)', 'var(--m3-on-surface-variant)']
  };
  const SIZES = { sm: [32, 18], md: [40, 22], lg: [56, 30] };

  function IconTile({ icon, tone = 'primary', size = 'md', shape = 'medium', filled = false, sx, ...props }) {
    const { Box } = MaterialUI;
    const { GoogleIcon } = window.Components;
    const [bg, fg] = TONES[tone] || TONES.primary;
    const [box, glyph] = SIZES[size] || SIZES.md;
    return (
      <Box
        aria-hidden="true"
        className="m3-icon-tile"
        sx={[{
          width: box,
          height: box,
          minWidth: box,
          flexShrink: 0,
          borderRadius: `var(--m3-shape-${shape})`,
          backgroundColor: bg,
          color: fg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }, ...(Array.isArray(sx) ? sx : [sx])]}
        {...props}
      >
        <GoogleIcon name={icon} size={glyph} filled={filled} style={{ color: 'inherit' }} />
      </Box>
    );
  }

  window.Components = window.Components || {};
  window.Components.IconTile = IconTile;
})();
